import { COMMON_STATUS } from "~/common/interfaces/common-status.enum";

export const boolToCommonStatus = (isActive: boolean) => isActive ? COMMON_STATUS.ACTIVE : COMMON_STATUS.INACTIVE;
